// extracted by mini-css-extract-plugin
module.exports = {"wrap":"index_wrap_9hDve","iconWrap":"index_iconWrap_2NCYK","icon":"index_icon_17yta","txt":"index_txt_22fcx","subTxt":"index_subTxt_2M5Q8"};